EASY.schedule.late(function () {
    function filterPath(string) {
        return string
            .replace(/^\//, '')
            .replace(/(index|default).[a-zA-Z]{3,4}jQuery/, '')
            .replace(/\/jQuery/, '');
    }
    const locationPath = filterPath(location.pathname);

    const animateScrollToHash = (hashSelector, event) => {
        let target;

        // Here is try-catch block to prevent errors if the selector is invalid,
        // for variant where we use input name as hash
        try {
            target = document.querySelector(hashSelector);
        } catch (e) { }

        if (!target) target = document.querySelector(`[name="${hashSelector.replace('#', '')}"]`);

        if (target) {
            if (event) event.preventDefault();

            const targetOffset = ERUI.topMenu?.offsetHeight || 0;

            const rect = target.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const topOffset = rect.top + scrollTop - targetOffset - 20;

            window.scroll({
                top: topOffset,
                behavior: 'smooth'
            });
        }
    };

    //----------------------------------------------------
    // Animate scroll on anchors
    //----------------------------------------------------
    jQuery('a[href*=\\#]').not('a[data-toggle], a[href=\\#], a[data-open-new-tab]').each(function () {
        jQuery(this).click(function (event) {
            const thisPath = filterPath(this.pathname) || locationPath;
            if (locationPath === thisPath
                && (location.hostname === this.hostname || !this.hostname)
                && this.hash.replace('#', '')) {
                animateScrollToHash(this.hash, event);
            }
        });
    });
    //----------------------------------------------------
    // Animate scroll on page load when hash in location
    //----------------------------------------------------
    if(location.hash.length > 1){
        EASY.utils.delayedRAF(function(){
            animateScrollToHash(location.hash);
        },1000);
    }
});
